import {Link, useParams, useNavigate} from 'react-router-dom';
import React, {useContext, useState} from 'react';
import {putApi, consoleLog} from '../../utils/functions';
//import {UserContext} from '../../utils/usercontext';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';


export default function Authentication() {

	const [response, setResponse] = useState(false);
	const {platform} = useParams();
	const navigate = useNavigate();
	//const user = useContext(UserContext);

	React.useEffect(() => {

		async function validateCode(url) {
			let params = new URLSearchParams();
			params.append('platform', platform);
			let param = url[1].split('&');
			let service = '';
			for( let i in param ) {
				let _split = param[i].split('=');
				if( _split[0] === 'state' ) service = parseInt(_split[1].substring(0,5)) || parseInt(_split[1].substring(0,4));
				params.append( _split[0], _split[1] );
			}
			
			//const y = await user.setWorker(service);
			
			const x = await putApi(`/v3/portal/platforms`, params);
			consoleLog(x.data);

			if( x.status === 200 ) {
				if( x.data.service ) redirect(`/${x.data.service}/platforms`); else redirect('/');
			} else {
				setResponse('error');
			}

		}

		function redirect(url) {
			navigate(url);
			
		}


		let url = window.location.href.split('?');
		
			

		if( url.length === 2 ) {
			

			validateCode(url);

			


		} else {
			setResponse('error');
		}
	}, []);

	return (
		<>
			<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
				<h4 className="fw-medium mb-0">Streaming Platforms</h4>
				<div className="ms-sm-1 ms-0">
					<nav>
						<ol className="breadcrumb mb-0">
							<li className="breadcrumb-item">{/*<Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link>*/}</li>
							<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
						</ol>
					</nav>
				</div>
			</div>

			<div className="main-content app-content">
				<div className="container-fluid">
					<Row>
							
						<Col lg={12}>
							<div className="card">
								<div className="card-header p-0">
									<div className="d-flex p-3 ">
										<div className="">
											<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
										</div>
										<div className="mt-0 text-start">
											<span className="fs-14 fw-semibold">Streaming Platforms</span>
											<p className="fs-13 text-muted mb-0">Connect your outgoing streams</p>
										</div>
									</div>
								</div>
								<div className="card-body">
									<Button size="sm" disabled={true}>Add Streaming Platform</Button>
									<Button size="sm" disabled={true}>Add Audio Platform</Button>
								</div>
								
							</div>
						</Col>

						
						
							
						<Col lg={12}>
							<div className="card">
								<div className="card-header">
									<span className="fs-14 fw-semibold">...</span>
								</div>
								<div className="card-body">
									<Row>
										{response === false &&
											<Col xs={12}>
												Processing the request, please wait ...
											</Col>
										}
										{response === 'error' &&
											<Col xs={4}>
												
												<div className="alert alert-danger alert-dismissible fade show custom-alert-icon shadow-sm" role="alert">
													<svg className="svg-danger" xmlns="http://www.w3.org/2000/svg" height="1.5rem" viewBox="0 0 24 24" width="1.5rem" fill="#000000"><path d="M0 0h24v24H0z" fill="none"></path><path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z"></path></svg>
													&nbsp;Failed to connect API to your service<br />
													&nbsp;Please check and try again ...
													<button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"><i className="bi bi-x"></i></button>
												</div>
											</Col>
										}
									</Row>
								</div>
								
							</div>
						</Col>

					</Row>
				</div>
			</div>
		</>
	)

}



